function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import{Button,Icon,FlexLayout,Col,Row,mediaQuery}from"@wp/src/components/common";import WpIcon from"@wp/src/common/images/WpIcon";export const InvestmentPreferenceSectionContainer=styled(FlexLayout)`
  padding: 16px;
  ${mediaQuery({width:["100%"],maxWidth:["824px"]})}
`;export const InvestmentPreferencesListContainer=styled.div`
  border: 1px solid ${props=>props.theme.colors.neutral300};
  box-sizing: border-box;

  & > :not(:last-child) {
    box-shadow: inset 0px -1px 0px ${props=>props.theme.colors.boxShadow};
  }
`;export const InvestmentPreferenceRow=styled(Row)`
  min-height: 70px;
  background: ${props=>props.theme.colors.white};
  text-align: left;
  ${mediaQuery({padding:["16px 8px","16px 8px"]})}
`;export const InvestmentPreferenceRowIconCol=styled(Col)`
  text-align: center;
`;export const InvestmentPreferenceRowValueCol=styled(Col)`
  ${mediaQuery({padding:["0px","0px 10px","0px 10px","0px 10px","0px 10px","0px 10px"],textAlign:["center","center","right","right","right","right"]})}
`;export const InvestmentPreferenceTextCol=styled(Col)`
  ${mediaQuery({textAlign:["center","center","left","left","left","left"]})}
`;export const InvestmentPreferenceRowResponse=styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 5px;

  color: ${props=>props.theme.colors.neutral900};
`;export const InvestmentPreferenceRowLabel=styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;

  color: ${props=>props.theme.colors.neutral500};
`;export const InvestmentPreferenceIconHolder=styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;

  background: ${props=>props.theme.colors.blue50};
  border-radius: 40px;
`;export const InvestmentPreferenceIcon=styled(WpIcon)`
  width: 20px;
  height: 20px;
`;export const EditInvestmentPreferenceButton=props=>{return React.createElement(Button,_extends({type:"default",variant:"light"},props))};export const ActionsContainer=styled.div`
  display: inline-block;
  font-style: normal;
  color: ${props=>props.theme.colors.neutral900};
`;export const ActionButtonsContainer=styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
`;export const ActionButtonWithIcon=styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
`;export const SyncIcon=props=>{return React.createElement(Icon,_extends({icon:"hugeicons:database-sync"},props,{className:`text-primary ${props.className}`}))};export const SubscriptionDetailsContainer=styled(FlexLayout)`
  justify-content: space-between;
  padding: 8px;
  width: 100%;
  border-radius: 8px;
  flex-wrap: nowrap;
  align-items: baseline;
  box-sizing: border-box;

  ${props=>{if(props.dontUseVariants){return"border:none; background: none;"}else if(props.isPlatinumTrialVariant){return`
        border: 1px solid #B6B6B6;
        background: linear-gradient(75deg, #F8F8F8 5.0%, #999 50.0%, #D6D4D4 100.0%);
      `}else if(props.isGoldTrialVariant){return`
        border: 1px solid #F59E0B;
        background: linear-gradient(75deg, #FFEA95 0.0%, #FFCC92 50.0%, #FF8B8B 95.0%);
      `}else{return`
      border: 1px solid ${props.theme.colors.neutral300};
      background-color: ${props.theme.colors.neutral50};
      `}}}
`;